import {Component, OnInit, ViewChild} from '@angular/core';
import {UserService} from '../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {EventTrackerService} from '../../services/event-tracker/event-tracker.service';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {ActivatedRoute} from '@angular/router';
import {ModalService} from '../../services/modal/modal.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {Platform} from '../../../models/platform';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {Channel} from '../../../models/common';
import {InfluencerSetting} from '../../../models/influencer-setting';
import {AuthService} from '../../core/auth.service';
import {Observable} from 'rxjs/Observable';
import {ChannelStatus, CommonConstant, FacebookAuthPreviousState, platformIconPath} from '../../app.constants';
import {Location} from '@angular/common';
import {CampaignService} from '../../services/campaign/campaign.service';
import {ValidationHandlerService} from '../../core/validation-handler.service';
import {NewInfluencerChanel} from '../../../models/influencer/new-influencer';
import {CampaignAcceptionPopupComponent} from '../campaign-acception-popup/campaign-acception-popup.component';

enum InfluencerTab {
  USER_SETTING = 1,
  SOCIAL_ACCOUNT = 2
}

@Component({
  selector: 'app-influencer-settings',
  templateUrl: './influencer-settings.component.html',
  styleUrls: ['./influencer-settings.component.scss']
})
export class InfluencerSettingsComponent extends CampaignAcceptionPopupComponent implements OnInit {

  public influencerId: number;
  // keep id to back to campaign list
  public mobileSelectedChannel;
  public selectedChannel;
  public campaignList: any[];
  public activeBottomBar: boolean;
  public platforms: Array<Platform> = [];
  public activeTabIndex: number | InfluencerTab.USER_SETTING;
  public target: string;
  public influencerSetting: InfluencerSetting = new InfluencerSetting();
  private logoImage: string;
  // notification status
  public notificationStatus: string;
  public notificationMessage: string;
  // blog need to authorize
  public blogChannel;
  // user avatar
  public userAvatar = './assets/images/bill-murray.png';
  @ViewChild('AlertAuthorizeFail') alertAuthorizeFail: AchooPopupComponent;
  @ViewChild('AlertRemoveSocial') alertRemoveSocial: AchooPopupComponent;
  @ViewChild('AlertRemoveSocialMobile') alertRemoveSocialMobile: AchooPopupComponent;
  @ViewChild('AlertAuthorizeChannel') alertAuthorizeChannel: AchooPopupComponent;
  @ViewChild('ModifyChannelNotification') modifyChannelNotification: AchooPopupComponent;
  public authorizeAccount;
  public isAddingChannel = false;
  public haveErrorOnAddingNewChannel = false;

  constructor(public influencerService: InfluencerService,
              public activatedRoute: ActivatedRoute,
              public location: Location,
              public auth: AuthService,
              public campaignService: CampaignService,
              public userService: UserService,
              public translateService: TranslateService,
              public modalService: ModalService,
              public validationError: ValidationHandlerService,
              public referenceDataService: ReferenceDataService,
              public eventTracker: EventTrackerService) {
    super(auth, influencerService, referenceDataService, validationError, activatedRoute, userService, modalService, eventTracker);
  }

  ngOnInit() {
    this.currentInfluencer = this.userService.getInfluencerInfo();
    this.influencerId = this.currentInfluencer.id;
    this.activeTabIndex = InfluencerTab.USER_SETTING;
    this.platforms = this.referenceDataService.platforms;
    this.activePage = FacebookAuthPreviousState.AUTHENTICATED;
    this.initializeInfluencerData();
    this.activatedRoute.queryParams.subscribe((params) => {
      this.fbAuthError = params.error;
      if (params.error || params.auth_result === 'success') {
        this.showSocialAccounts();
      }
      this.loadInfluencerChannels(this.influencerId, () => {
        if (this.fbAuthError) {
          super.handleFbAuthOnError();
        }
      });
      super.intializedChannelListFromLocalData();
      this.auth.removeInfluencerChannelAuthorizationLocalData();
    });
  }

  back() {
    this.location.back();
  }

  private initializeInfluencerData() {
    const currentUser = this.auth.getUser();
    const currentInfluencer = this.userService.getInfluencerInfo();
    this.influencerSetting.first_name = currentUser.data.firstName;
    this.influencerSetting.last_name = currentUser.data.lastName;
    this.influencerSetting.phone = currentInfluencer.phone;
    this.influencerSetting.email = currentUser.data.email;
    this.influencerSetting.rewrite_email = currentInfluencer.systemEmail;
    this.influencerSetting.avatar = currentInfluencer.profilePicture;
    this.userAvatar = currentInfluencer.profilePicture;
  }

  private loadInfluencerChannels(influencerId, callback?) {
    this.influencerService.getInfluencerChannels(influencerId).subscribe((res) => {
      this.listExistingChannel = res;
      if (callback) {
        callback();
      }
    });
  }

  private onDismissNotification() {
    this.notificationStatus = null;
    this.notificationMessage = null;
  }

  get platformBackground() {
    return this.userService.platformBackground;
  }
  showUserSettings() {
    this.activeTabIndex = InfluencerTab.USER_SETTING;
    this.hideSettingAuthorizeBlogBox();
  }

  showSocialAccounts() {
    this.activeTabIndex = InfluencerTab.SOCIAL_ACCOUNT;
  }

  get isActiveUserSettingsTab() {
    return this.activeTabIndex === InfluencerTab.USER_SETTING;
  }

  get isActiveSocialAccountsTab() {
    return this.activeTabIndex === InfluencerTab.SOCIAL_ACCOUNT;
  }

  showSettingAuthorizeBlogBox(evt) {
    this.blogChannel = evt;
    this.activeBottomBar = true;
  }

  authorizeChannel(evt) {
    if (evt.channel === 'blogs') {
      this.showSettingAuthorizeBlogBox(evt.data);
    } else {
      super.authorizeChannel(evt);
    }
  }

  addNewChannel() {
    const newInfluencerChannel = new NewInfluencerChanel(this.mobileSelectedChannel, ChannelStatus.UNAUTHORIZE);
    newInfluencerChannel.handle = this.authorizeAccount;
    newInfluencerChannel.influencerId = this.influencerId;

    const selectedPlatform = this.platforms.find(p => p.id === this.mobileSelectedChannel);
    const newChannel = new Channel(0, this.authorizeAccount, ChannelStatus.UNAUTHORIZE, this.influencerId, selectedPlatform);
    newChannel.index = this.newChannelIndex++;
    this.listNewChannel.push(newChannel);
    this.isAddingChannel = true;
    this.closeChannelModal();
    this.influencerService.addChannelByInfluencer(this.influencerId, newInfluencerChannel).subscribe((res) => {
      this.showNotificationOnCreateSuccess();
      this.afterAddingNewAuthorizedChannel(this.influencerId, false);
    }, (error) => {
      const errorChannelComp = this.channelComponents.filter(c => c.channelData.index === newChannel.index);
      errorChannelComp.forEach(c => c.platformSetting.status = ChannelStatus.AUTHORIZE_FAILED);
      const errorCode = error && error.error ? error.error.data : null;
      this.handleChannelError(`new_${newChannel.index}`, errorCode);
    });
  }

  private afterAddingNewAuthorizedChannel(influencerId, hasError: boolean) {
    this.isAddingChannel = false;
    if (hasError) {
      this.listNewChannel = this.listNewChannel.filter(c => c.id !== 0);
      this.haveErrorOnAddingNewChannel = true;
    } else {
      this.loadInfluencerChannels(influencerId, () => {
        this.listNewChannel = this.listNewChannel.filter(c => c.id !== 0);
      });
    }
  }

  hideSettingAuthorizeBlogBox() {
    this.blogChannel = null;
    this.activeBottomBar = false;
  }

  addChannel() {
    this.modalService.openInCenter(this.alertAuthorizeChannel, () => {
      // clear unsave channel data before closing authorization modal
      this.mobileSelectedChannel = null;
      this.authorizeAccount = null;
    });
  }

  closeChannelModal() {
    // clear unsave channel data before closing authorization modal
    this.mobileSelectedChannel = null;
    this.authorizeAccount = null;
    this.modalService.close();
  }

  onClose() {
    this.modalService.close();
  }

  authorizeBlog() {
    this.blogChannel.type = ChannelStatus.AUTHORIZED;
    this.influencerService.updateInfluencerChannel(this.blogChannel.id, this.blogChannel).subscribe((res) => {
      this.loadInfluencerChannels(this.influencerId);
      this.hideSettingAuthorizeBlogBox();
    }, (err) => {
      super.handleChannelError(this.blogChannel.id, CommonConstant.BLOG_CHANNEL_AUTH_FAIL);
    });
  }

  updateSetting() {
    this.validationError.resetErrors();
    const {first_name, last_name, email, rewrite_email, phone, avatar, new_password, old_password, repeat_new_password} = this.influencerSetting;
    const currentInfluencer = this.userService.getInfluencerInfo();
    const {domain, isActive, pending_completed, gender, country, influencerLanguages} = currentInfluencer;
    const influencerData = {
      id: this.influencerId,
      first_name, email, phone, domain, isActive, pending_completed, gender,
      profileImage: avatar,
      system_email: rewrite_email,
      country: country.id,
      languages: influencerLanguages.length > 0 ? influencerLanguages.map(lang => lang.language.id) : [CommonConstant.INTERNATIONAL_LANGUAGE]
    };
    const companyId = this.userService.getCompanyId();
    const influencerSettingObservers = [
      this.userService.updateUser(first_name, last_name, email, this.logoImage),
      this.influencerService.updateInfluencerData(this.influencerId, influencerData),
    ];
    if (new_password && old_password) {
      if (repeat_new_password !== new_password) {
        this.validationError.shouldDisplayErrors(true);
        this.validationError.updateErrors([{
          name: 'repeat_new_password',
          message: this.translateService.instant('influencer_settings.messages.new_password_not_match')
        }]);
        return;
      } else {
        influencerSettingObservers.push(this.userService.updatePassword(old_password, new_password));
      }
    }
    Observable.forkJoin(influencerSettingObservers).subscribe(res => {
      this.auth.getUserData();
      this.updateInfluencerData(companyId);
    }, (err) => {
      if (err.error.message === 'Wrong password.') {
        this.validationError.shouldDisplayErrors(true);
        this.validationError.updateErrors([{
          name: 'old_password',
          message: this.translateService.instant('influencer_settings.messages.old_password_not_correct')
        }]);
      }
    });
  }

  private updateInfluencerData(companyId) {
    this.userService.loadInfluencerInfoByCompanyId(companyId).subscribe(res => {
      this.userService.addInfluencerInfo(res);
    });
  }

  onUserAvatarSelected(evt) {
    if (!evt || !evt.target || !evt.target.files) {
      return;
    }
    const selectedImageList = <FileList>((<any>evt.target).files);
    if (!selectedImageList.length) {
      return;
    }
    this.uploadUserAvatar(selectedImageList[0]);
  }

  get isIGChannel() {
    return this.mobileSelectedChannel
      && (this.mobileSelectedChannel === platformIconPath.instagram.id || this.mobileSelectedChannel === platformIconPath.facebook.id);
  }
  get isSelectedChannel() {
    return this.mobileSelectedChannel;
  }

  private showNotificationOnCreateSuccess() {
    this.notificationStatus = this.translateService.instant('notification.success');
    this.notificationMessage = this.translateService.instant('influencer_settings.messages.create_channel_success');
    this.modalService.open(this.modifyChannelNotification, this.onDismissNotification.bind(this), true);
  }

  private uploadUserAvatar(logo) {
    this.campaignService.validateMaterialUploadFile(logo);
    // Only upload one file on each select
    const formData = new FormData();
    formData.append('file', logo);

    this.campaignService.uploadFile(formData).subscribe(data => {
      if (data) {
        this.influencerSetting.avatar = data.diskFileName;
        this.userAvatar = data.diskFileName;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-settings/influencer-settings.component.ts